// for RazorPay
export const RZ_KEY = "rzp_live_mqedeCiU8xMBCp";
export const RZ_CHANNEL = "razorpay2";

//  for CC Avenue

export const CCA_MERCHANT_ID = "2779264";
